import { get } from './actions/get';
import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';

const actions = {
  get
};

export type IInvitationActions = TActionsWithoutState<typeof actions>;

export default actions;
